// Defensive wrapper around window.localStorage.
//
// Accessing localStorage throws in several real-world mobile situations:
// private/incognito browsing with site data blocked, in-app browsers
// (Instagram/Facebook webviews), Safari Lockdown mode, or when the storage
// quota is exhausted. Those throws happen inside React state initializers and
// at module load — before any ErrorBoundary can catch them — which is what
// turned the app into a blank/black screen on mobile.
//
// Every method here swallows the failure so callers can treat storage as
// best-effort: reads return null, writes are no-ops. State simply falls back
// to its in-memory default instead of crashing the whole app.

export const safeStorage = {
  getItem(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  setItem(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      /* storage unavailable — degrade silently */
    }
  },

  removeItem(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* storage unavailable — degrade silently */
    }
  },
};

export default safeStorage;
